import { render, staticRenderFns } from "./LogoNationalGeographic.vue?vue&type=template&id=6c01b734&scoped=true&"
import script from "./LogoNationalGeographic.vue?vue&type=script&lang=js&"
export * from "./LogoNationalGeographic.vue?vue&type=script&lang=js&"
import style0 from "./LogoNationalGeographic.vue?vue&type=style&index=0&id=6c01b734&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c01b734",
  null
  
)

export default component.exports